module.exports = __webpack_public_path__ + "static/media/S_10.41194106.png";